module.exports = __webpack_public_path__ + "static/media/Asset1080.9a4ca2fc.png";